export const MAIN_PATH = "/";
export const CREATE_GAME_PATH = "/create-game";
export const CREATE_ACCOUNT_PATH = "/create-account/";
export const LOGIN_PATH = "/login/";
export const JOIN_GAME_PATH = "/join-game/:gameId";
export const GAME_PATH = "/game/:gameId";
export const GAME = "/game/";
export const JOIN_GAME = "/join-game/";
export const SUMMARY = `${GAME}summary`;
